/* Tea Lab contact page: marks fields that failed the browser check, stops double sending and moves focus to the thank-you or error message. */
(function () {
  function setup(form) {
    if (form.__tlc) return;
    form.__tlc = true;
    var btn = form.querySelector('[data-tlc-submit]');
    var label = btn && btn.querySelector('[data-tlc-label]');
    var original = label ? label.textContent : '';
    form.addEventListener('invalid', function () { form.classList.add('was-validated'); }, true);
    form.addEventListener('submit', function () {
      if (!btn || !form.checkValidity()) return;
      btn.setAttribute('aria-busy', 'true');
      if (label && btn.getAttribute('data-sending')) label.textContent = btn.getAttribute('data-sending');
      setTimeout(function () { btn.disabled = true; }, 0);
    });
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted || !btn) return;
      btn.disabled = false; btn.removeAttribute('aria-busy');
      if (label) label.textContent = original;
    });
    var msg = form.querySelector('[data-tlc-focus]');
    if (msg) {
      try { msg.focus({ preventScroll: true }); } catch (err) { msg.focus(); }
      if (msg.scrollIntoView) msg.scrollIntoView({ block: 'center', behavior: 'auto' });
    }
  }
  function init(root) {
    (root || document).querySelectorAll('[data-tlc-form]').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();